import {Component} from '@angular/core';
import {User} from '../../shared/model/user.entity';
import {UserService} from '../../api/user.service';
import {SpinnerService} from '../../spinner/spinner.service';
import {NotificationServiceBus} from '../../notification/notification.service';
import {GLOBAL} from '../../shared/global';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.css'],
})
export class UserPasswordComponent {}



// WEBPACK FOOTER //
// ./src/app/user-management/user-password/user-password.component.ts